<template>
    <div class="form__container" :id="'input_' + inputData.id">
        <p class="form__heading">
            <span>{{ inputData.name }}</span>
            <required-indicator :inputData="inputData"></required-indicator>
        </p>
        <p class="form__description" :id="'description_' + inputData.id" v-if="inputData.desc">{{ inputData.desc }}</p>
        <div class="form__inputs">
            <div class="form__inputs-box" v-for="inputOption in inputData.inputoptions.sort((a, b) => a.order - b.order)" :key="inputOption.id">
                <input class="form__input form__input--radio"
                    :aria-describedby="(inputData.desc ? ('description_' + inputData.id) : '') + (inputData.error ? (' error_' + inputData.id) : '')"
                    type="radio"
                    :id="'inputField_' + inputOption.id"
                    :name="'input_' + inputData.id" 
                    :value="inputOption.id"
                    :required="inputData.required"
                    :class="inputData.error ? 'form__input--error' : ''"
                    v-model="selected[0]"
                    v-on:change="updateInputOptions">    
                <label class="form__label form__label--radio" :for="'inputField_' + inputOption.id">{{ inputOption.text }}</label>
            </div>
        </div>
        <div class="form__error" :id="'error_' + inputData.id" v-if="inputData.error" role="alert">{{ inputData.error }}</div>
        <div>
            <span class="form__explanation" v-if="inputData.explanation">{{ inputData.explanation }}</span>
        </div>
    </div>
</template>

<script>
import RequiredIndicator from './RequiredIndicator.vue';

export default {
    props: ['inputData'],
    emits: ['inputOptions'],
    components: {
        'required-indicator': RequiredIndicator
    },
    data() {
        return{
            selected: [],
            options: [],
        }
    },
    methods: {
        updateInputOptions(){
            this.$emit('inputOptions', this.options, this.selected);
        },
        updateOptions(){
            this.options = [];
            this.inputData.inputoptions.forEach((inputOption) => {
                this.options.push(inputOption.id);
            });
        }
    },
    mounted(){
        this.updateOptions();
    },
    watch: {
        inputData(){
            this.updateOptions();
        },
        selectedOptions(newVal, oldVal) {
            const selectedIds = newVal.map(i => i.id);
            for (const id of selectedIds) {
                if (!id || !this.options.includes(id) || this.selected.includes(id)) {
                    continue;
                }

                this.selected.push(id);
            }
        }
    }
}
</script>